import httpManager from "@/app/shared/utils/httpManager";

export async function fetchWorkspaceTypifications(ticketId) {
  const url = `/workspace/tickets/${ticketId}/typifications/`;
  const response = await httpManager.post(url);
  return response.data;
}
